import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "my-section" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "my-title" }, " Strumenti sviluppatore ", -1)
const _hoisted_4 = { class: "my-card mb-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold my-card--header" }, " Actions ", -1)
const _hoisted_6 = { class: "my-buttons my-card--body" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Aggiorna ")
const _hoisted_8 = { class: "flex flex-col md:flex-row mb-10 gap-5" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Login ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" oggi")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Account ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" connessi ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" oggi")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Richieste ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" oggi")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Errori ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" oggi")
const _hoisted_23 = { class: "flex flex-col md:flex-row flex-wrap w-full gap-y-10 justify-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_StatCard = _resolveComponent("StatCard")!
  const _component_ChartDisc2LinWidget = _resolveComponent("ChartDisc2LinWidget")!
  const _component_ChartTime2LinWidget = _resolveComponent("ChartTime2LinWidget")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            class: "is-secondary",
            icon: "fas fa-sync",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getData()))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_StatCard, { class: "" }, {
          stat: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.countLoginsToday), 1)
          ]),
          label: _withCtx(() => [
            _hoisted_9,
            _hoisted_10,
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_StatCard, { class: "" }, {
          stat: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.countAccountsToday), 1)
          ]),
          label: _withCtx(() => [
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _hoisted_15,
            _hoisted_16
          ]),
          _: 1
        }),
        _createVNode(_component_StatCard, { class: "" }, {
          stat: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.countRequestsToday), 1)
          ]),
          label: _withCtx(() => [
            _hoisted_17,
            _hoisted_18,
            _hoisted_19
          ]),
          _: 1
        }),
        _createVNode(_component_StatCard, {
          class: _normalizeClass({ 'is-error': _ctx.countErrorsToday > 0 })
        }, {
          stat: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.countErrorsToday), 1)
          ]),
          label: _withCtx(() => [
            _hoisted_20,
            _hoisted_21,
            _hoisted_22
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_ChartDisc2LinWidget, {
          id: "grafico1",
          class: "w-full md:w-9/20",
          data: _ctx.reqDayRequestsDataAccounts,
          height: 250,
          title: "Richieste",
          subtitle: "Richieste al giorno nelle ultime due settimane"
        }, null, 8, ["data"]),
        _createVNode(_component_ChartTime2LinWidget, {
          id: "grafico3",
          class: "w-full md:w-9/20",
          data: _ctx.reqMinuteRequestsDataAccounts,
          height: 250,
          title: "Richieste",
          subtitle: "Richieste al minuto negli ultimi due giorni"
        }, null, 8, ["data"]),
        _createVNode(_component_ChartDisc2LinWidget, {
          id: "grafico2",
          class: "w-full md:w-9/20",
          data: _ctx.reqDayRequestsDataErrors,
          height: 250,
          title: "Errori",
          subtitle: "Errori al giorno nelle ultime due settimane"
        }, null, 8, ["data"]),
        _createVNode(_component_ChartTime2LinWidget, {
          id: "grafico4",
          class: "w-full md:w-9/20",
          data: _ctx.reqMinuteRequestsDataErrors,
          height: 250,
          title: "Errori",
          subtitle: "Errori al minuto negli ultimi due giorni"
        }, null, 8, ["data"]),
        _createVNode(_component_ChartDisc2LinWidget, {
          id: "grafico5",
          class: "w-full md:w-9/20",
          data: _ctx.reqDayLoginsDataAccounts,
          height: 250,
          title: "Accessi",
          subtitle: "Accessi al giorno nelle ultime due settimane"
        }, null, 8, ["data"]),
        _createVNode(_component_ChartDisc2LinWidget, {
          id: "grafico6",
          class: "w-full md:w-9/20",
          data: _ctx.reqDayLoginsFailedDataAccounts,
          height: 250,
          title: "Tentativi di accesso falliti",
          subtitle: "Tentativi di accesso falliti al giorno nelle ultime due settimane"
        }, null, 8, ["data"])
      ])
    ])
  ]))
}